export default "__VITE_ASSET__4559584a__"